import { FETCH_START_CONTENT } from './constants'

const initialState = {
  isFetching: false,
  startercontent: [],
  currentPhoneId: ''
}

export default function getingStartedReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_START_CONTENT.REQUEST: {
      return {
        ...state,
        isFetching: true,
        startercontent: []
      }
    }
    case FETCH_START_CONTENT.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        startercontent: action.startContent,
        currentPhoneId: action.currentPhoneId
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/GettingStarted/reducer.js